"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const DEFAULT_COOLDOWN_MS = 1500;
function useSubmissionGuard(cooldownMs = DEFAULT_COOLDOWN_MS) {
    const isSubmittingRef = (0, react_1.useRef)(false);
    const timeoutRef = (0, react_1.useRef)(null);
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const trySubmit = (0, react_1.useCallback)((callback) => {
        if (isSubmittingRef.current) {
            return false;
        }
        isSubmittingRef.current = true;
        setIsSubmitting(true);
        callback();
        timeoutRef.current = setTimeout(() => {
            isSubmittingRef.current = false;
            setIsSubmitting(false);
            timeoutRef.current = null;
        }, cooldownMs);
        return true;
    }, [cooldownMs]);
    (0, react_1.useEffect)(() => () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }, []);
    return { isSubmitting, trySubmit };
}
exports.default = useSubmissionGuard;
